import { Subscription } from '@/shared/types/Billing';

export const isSubscriptionExpired = (subscriptionEndDate: Subscription['current_period_end']) => {
  const now = new Date();
  const expiryDate = new Date(subscriptionEndDate);
  return now > expiryDate;
};
